import { NaturalLowerOrEqualThan } from 'src/utils/types/NaturalLowerOrEqualThan'

/**
 * Function to generate an array of numbers from 1 to `limit`, inclusive.
 */
export const naturalRange = <N extends number>(
  limit: N
): NaturalLowerOrEqualThan<N>[] => {
  const length = Math.floor(Math.max(limit, 0))
  const range = Array.from({ length }, (_, i) => i + 1)

  return range as NaturalLowerOrEqualThan<N>[]
}
